import * as React from 'react'

export const MetaIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={10} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16 6.498C16 8.65 15.015 10 13.242 10c-1.565 0-2.395-.816-3.922-3.222l-.785-1.24c-.207-.295-.363-.571-.53-.826-.503.797-1.178 1.958-1.178 1.958C5.152 9.42 4.213 10 2.905 10 1.085 10 0 8.649 0 6.559 0 3.186 1.994 0 4.598 0c1.255 0 2.345.582 3.62 2.11C9.144.93 10.17 0 11.481 0 13.96 0 16 2.965 16 6.498ZM7.185 3.533c-1.072-1.465-1.772-1.899-2.61-1.899-1.548 0-2.845 2.503-2.845 4.953 0 1.144.462 1.786 1.24 1.786.755 0 1.225-.448 2.58-2.448 0 0 .618-.923 1.635-2.392Zm6.095 4.84c.805 0 1.173-.649 1.173-1.767 0-2.93-1.358-5.316-3.08-5.316-.83 0-1.528.61-2.373 1.84.235.325.477.684.732 1.07l.938 1.472c1.467 2.22 1.838 2.7 2.61 2.7Z"
      fill="#282421"
    />
  </svg>
)
